import { Box, Button, IconButton } from '@mui/material';
import { Link } from "react-router-dom";
import LightMode from '@mui/icons-material/LightMode';
import DarkMode from '@mui/icons-material/DarkMode';

function Header({ themeMode, toggleTheme }) {
  return (
    <Box
      component="header"
      sx={{
        borderBottom: '1px solid',
        borderColor: 'divider',
        padding: { xs: 1.5, sm: 2 },
        flexShrink: 0,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        {/* Name/Logo */}
        <Box
          component={Link}
          to="/"
          sx={{
            fontSize: { xs: '1rem', sm: '1.1rem' },
            fontWeight: 400,
            textDecoration: 'none',
            color: 'text.secondary',
            '&:hover': {
              color: 'text.primary',
              opacity: 0.7,
            },
          }}
        >
          Rojan Thomas
        </Box>

        {/* Navigation */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, sm: 2 } }}>
          <Button
            component={Link}
            to="/about"
            sx={{
              color: 'text.primary',
              fontSize: { xs: '0.875rem', sm: '1rem' },
              '&:hover': {
                backgroundColor: 'transparent',
                opacity: 0.7,
              },
            }}
          >
            About
          </Button>
          <Button
            component={Link}
            to="/portfolio"
            sx={{
              color: 'text.primary',
              fontSize: { xs: '0.875rem', sm: '1rem' },
              '&:hover': {
                backgroundColor: 'transparent',
                opacity: 0.7,
              },
            }}
          >
            Portfolio
          </Button>
          <IconButton
            onClick={toggleTheme}
            sx={{
              color: 'text.primary',
              marginLeft: 1,
            }}
            aria-label="Toggle theme"
          >
            {themeMode === 'dark' ? <LightMode /> : <DarkMode />}
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
}

export default Header;
